import React, { useState, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { STATUS_MAPPING } from "../../../common/Constants";
import { AUDIT_STATUS } from "../../../../utils/auditStateMachine";

function SubmitToAuditorModal({ onClose, onSubmit, selectedRows, auditStatus }: any) {
  const [counts, setCounts] = useState<any[]>([]);

  useEffect(() => {
    if (selectedRows) {
      const _counts: any = {};
      selectedRows.forEach((row: any) => {
        if(!row.published) {
          if (!_counts[row.status]) {
            _counts[row.status] = 0;
          }
          _counts[row.status] = _counts[row.status] + 1;
        }
      });

      setCounts(Object.keys(_counts).map(key => {
        return {
          key,
          label: STATUS_MAPPING[key],
          count: _counts[key]
        }
      }));
    }

  }, [selectedRows]);

  return (
    <>
      <Modal show={true} backdrop="static" animation={false} size="lg">
        <Modal.Header closeButton={true} onHide={onClose}>
          <Modal.Title className="bg">Submit to Auditor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-4">
            <div className="col-12">
              {selectedRows.length == 0 && [AUDIT_STATUS.FINAL_AUDIT_PENDING].includes(auditStatus) && <p>All the activities will be submitted for final audit.</p>}
              {selectedRows.length > 0 && <p>There are <strong>{selectedRows.length} {selectedRows.length > 1 ? 'activities' : 'activity'}</strong> available for submission.</p>}
              <div className="row justify-content-center my-3">
                <div className="col-8">
                  {
                    counts.map(count => {
                      return (
                        <div className="row my-1" key={count.key}>
                          <div className={`col-7 status-${count.key}`}><strong>{count.label}</strong></div>
                          <div className="col-4">{count.count}</div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
              <p>Upon submission to Auditor, you will not be able to edit them further</p>
              <p>Do you want to submit ? click "Yes"</p>
              <p>To cancel, click "No"</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button variant="outline-secondary" onClick={onClose} className="btn btn-outline-secondary">
            No
          </Button>
          <div>
            <Button variant="primary" onClick={onSubmit}>
              Yes
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default SubmitToAuditorModal;